// extracted by mini-css-extract-plugin
export default {"relatedEvents":"OtherEventsYouMayLike-module__relatedEvents___2d9Rg","carouselDesktop":"OtherEventsYouMayLike-module__carouselDesktop___2ZWj6"};